import { getContracts, getProvider } from "@/lib/contracts";

/**
 * 合约不可变常量的全局缓存。
 *
 * TIER_BURN / FUSE_BURN_* 都是合约里的 constant，renounce 后更是永久固定，
 * 但原本每次打开对应面板都要重新读一次。这里统一读一次并缓存，
 * 且强制走项目 RPC（而非钱包 RPC），避免钱包指向别的网络时读出错误数值。
 *
 * inflight 去重保证多个面板同时挂载时只发一次请求。
 */

let fuseBurnCache: { two: bigint; three: bigint } | null = null;
let fuseBurnInflight: Promise<{ two: bigint; three: bigint }> | null = null;

/** 融合费用：two = 2 猫融合，three = 3 猫融合 */
export async function getFuseBurnCosts(): Promise<{ two: bigint; three: bigint }> {
  if (fuseBurnCache) return fuseBurnCache;
  if (!fuseBurnInflight) {
    const { nft } = getContracts(getProvider());
    fuseBurnInflight = Promise.all([nft.FUSE_BURN_TWO(), nft.FUSE_BURN_THREE()])
      .then(([two, three]: [bigint, bigint]) => {
        fuseBurnCache = { two, three };
        return fuseBurnCache;
      })
      .catch(() => ({ two: 0n, three: 0n }));
  }
  return fuseBurnInflight;
}

const tierBurnCache = new Map<number, bigint>();
const tierBurnInflight = new Map<number, Promise<bigint>>();

/** 累计燃烧阈值 TIER_BURN[index] */
export async function getTierBurn(index: number): Promise<bigint> {
  const cached = tierBurnCache.get(index);
  if (cached !== undefined) return cached;

  let inflight = tierBurnInflight.get(index);
  if (!inflight) {
    const { nft } = getContracts(getProvider());
    inflight = nft
      .TIER_BURN(index)
      .then((v: bigint) => {
        tierBurnCache.set(index, v);
        return v;
      })
      .finally(() => tierBurnInflight.delete(index));
    tierBurnInflight.set(index, inflight);
  }
  return inflight;
}
